// Phaser bindText / onLangChange. Delegates to @learnforge/i18n/phaser, with
// luminary's singleton i18n instance baked in so callers don't have to thread
// it through.

import type Phaser from 'phaser';
import {
  bindText as bindTextShared,
  onLangChange as onLangChangeShared,
} from '@learnforge/i18n/phaser';
import { _getInstance } from './index';
import type { Direction, LangCode, TranslationKey } from './types';

export function bindText(
  text: Phaser.GameObjects.Text,
  key: TranslationKey,
  scene: Phaser.Scene,
  params?: Record<string, string | number>,
): Phaser.GameObjects.Text {
  return bindTextShared(_getInstance(), text, key, scene, params);
}

export function onLangChange(
  scene: Phaser.Scene,
  cb: (lang: LangCode, dir: Direction) => void,
): void {
  onLangChangeShared(_getInstance(), scene, cb);
}
